/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function TagOffIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M18.63 6c1.09 0 2.115.448 2.885 1.215l11.283 11.258a4.124 4.124 0 0 1 0 5.82l-8.527 8.508a4.147 4.147 0 0 1-5.834 0L7.154 21.543C6.384 20.776 6 19.753 6 18.665V9.07A3.074 3.074 0 0 1 9.077 6zM9.077 18.665c0 .256.064.512.257.703l11.283 11.258c.385.384 1.09.384 1.475 0l8.526-8.507a.972.972 0 0 0 0-1.471L19.335 9.39c-.193-.192-.449-.32-.705-.32H9.077zm4.103-7.548c1.09 0 2.052.96 2.052 2.047 0 1.151-.962 2.047-2.052 2.047a2.023 2.023 0 0 1-2.051-2.047c0-1.088.897-2.047 2.051-2.047"/>}
        </IconWrapper>);
}
